import { useContext } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { B as BiomePortalIdContext } from '../BiomePortalIdProvider/BiomePortalIdProvider.js';
import { p as positionedOverlayContainerCss } from '../shared/shared.js';
import { B as BiomeTooltipProvider } from '../tooltipContext/tooltipContext.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { C as ClientOnlyPortal } from '../../overlays/ClientOnlyPortal/ClientOnlyPortal.js';
import { T as TooltipOverlay } from '../../overlays/TooltipOverlay/TooltipOverlay.js';
import { useTheme } from '../../hooks/useTheme.js';

var SELECTOR = "tooltip-container";
function MountedTooltipOverlayAndProvider(_ref) {
  var children = _ref.children;
  var portalId = useContext(BiomePortalIdContext);
  var _useTheme = useTheme(),
    zLevel = _useTheme.base.zLevel;
  return jsxs(BiomeTooltipProvider, {
    children: [children, jsx(ClientOnlyPortal, {
      selector: "#".concat(SELECTOR).concat(portalId),
      children: jsx(TooltipOverlay, {})
    }), jsx("div", {
      id: "".concat(SELECTOR).concat(portalId),
      css: merge(positionedOverlayContainerCss, {
        zIndex: zLevel.tooltip
      })
    })]
  });
}

export { MountedTooltipOverlayAndProvider as M };
//# sourceMappingURL=MountedTooltipOverlayAndProvider.js.map
